export default __webpack_public_path__ + "static/media/fed_black_logo.b6d78fc5.svg";